import { httpErrorHook } from '@/hooks/http-error'
import { httpResponseMessageHook } from '@/hooks/http-response-message'

export default [
  httpErrorHook,
  httpResponseMessageHook
]
